import { Auth, Hub } from 'aws-amplify';
import { AmplifyClient } from '../../../project/amplify-client';
import BaseComponent from '../../../foundation/base-component';
import userService from '../../../general/js/user/user-service';
import { isEmpty } from '../../sso/components/utils/obj-utils';

export default class OauthHandlerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init = () => {
        AmplifyClient.init();
        Hub.listen('auth', ({ payload: { event } }) => {
            switch (event) {
                case 'signIn':
                    this.handleCustomOAuthState();
                    break;
                case 'customOAuthState':
                    this.handleCustomOAuthState();
                    break;
                // case 'signOut':
                //     this.handleRedirectAfterSignOut();
                //     break;
                default:
                    break;
            }
        });
    }

    handleRedirectAfterSignOut() {
        userService.redirectAfterSignOut();
    }

    handleCustomOAuthState() {
        Auth.currentAuthenticatedUser({ bypassCache: true })
            .then(() => {
                const returnUrl = userService.getHostedUIReturnUrlFromSessionStorage(true);

                if (!isEmpty(returnUrl) && window.location.href !== returnUrl) {
                    window.location.href = returnUrl;
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
